import ReactDOM from 'react-dom'
import QRCode from 'qrcode.react'
import { RenderPDF } from 'templates/template'
import { pdf } from '@react-pdf/renderer'
import download from 'downloadjs'
import Certificate from 'interfaces/Certificate'
import TemplateService from 'services/TemplateService'
import FileService from 'services/FileService'

export const downloadPDF = async (certificate: Certificate) => {
  try {
    const template = await TemplateService.getTemplate(certificate.templateId)

    if (!template?.imagePath) {
      alert('La plantilla no tiene imagen asociada.')
      return
    }

    const imageDataUrl = await FileService.fetchImageDataUrl(template.imagePath)

    const renderAndDownload = async (qrCodeDataUri: string | null) => {
      const blob = await pdf(
        RenderPDF(qrCodeDataUri, certificate, imageDataUrl)
      ).toBlob()
      download(blob, 'certificado.pdf')
    }

    if (certificate.hasQR && certificate.qrCode) {
      generateQR(certificate.qrCode)
      await new Promise((r) => setTimeout(r, 150))

      const qrCodeCanvas = document.getElementById('qr') as HTMLCanvasElement | null
      if (!qrCodeCanvas) {
        throw new Error('No se pudo generar el código QR.')
      }

      const qrCodeDataUri = qrCodeCanvas.toDataURL('image/jpeg', 1.0)
      await renderAndDownload(qrCodeDataUri)

      document.getElementById('divqr')?.remove()
    } else {
      await renderAndDownload(null)
    }
  } catch (err) {
    console.error(err)
    const message =
      err instanceof Error ? err.message : 'No se pudo generar la vista previa.'
    alert(message)
  }
}

const generateQR = (text: string) => {
  const existing = document.getElementById('divqr')
  if (existing) existing.remove()

  const newDiv = document.createElement('div')
  newDiv.setAttribute('id', 'divqr')
  newDiv.style.top = '0'
  newDiv.style.left = '0'
  newDiv.style.position = 'fixed'
  newDiv.style.visibility = 'hidden'
  document.body.appendChild(newDiv)

  ReactDOM.render(
    <QRCode bgColor="transparent" id="qr" value={text} />,
    newDiv
  )
}
